import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { ReactComponent as DiscountIcon } from '../../common/icons/discount.svg';
import { DiscountLabel } from './DiscountCodeScreen';
import DiscountInfo, {
  DiscountInfoGrid,
  getDiscount,
  getTotalSpending,
} from './elements/DiscountInfo';
import CartContext from '../contexts/CartContext';
import handleConfirmation from '../utils/adaHandler';

const FooterStyle = styled.div.attrs({
  className: 'GiftBox-Footer',
})`
  padding: 16px 20px 20px 16px;
  background-color: #fafafa;
  border-top: solid 1px #e9e9e9;
  margin: 0 -8px -8px -8px;
  position: sticky;
  bottom: 0;
  width: calc(100% + 16px);

  grid-row-start: 2;
  grid-row-end: 3;

  display: flex;
  justify-content: space-between;
  flex-flow: column wrap;

  ${DiscountInfoGrid} {
    padding-top: 1rem;
    width: fit-content;
    grid-column-gap: 0.5rem;
    grid-row-gap: 0.3rem;
    justify-items: start;
  }

  @media only screen and (min-width: 360px) {
    flex-flow: row wrap;
    gap: 1rem;
    ${DiscountInfoGrid} {
      grid-column-gap: 1rem;
      align-items: center;
      justify-items: end;
      padding-top: 0px;
    }
  }

  ${(props) =>
    props.padding &&
    props.padding === 'small' &&
    css`
      padding: 11px 10px 16px 10px;
    `}
`;

const Button = styled.div`
  align-items: center;
  display: flex;
  .Giftbox-Discount-Code-Switch-Icon {
    margin-right: 0.5rem;
  }

  cursor: pointer;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

export default function Footer({ discountCode, setCurrentScreen, settings }) {
  const { cart } = useContext(CartContext);
  const onClick = () => {
    setCurrentScreen('discount');
    // Resetting focus
    document.activeElement.blur();
  };
  const totalSpending = getTotalSpending(cart);
  const discount = getDiscount(cart, totalSpending);
  const renderDiscountInfo = settings.discount_adjust_spending && cart;

  if (discountCode) {
    return (
      <FooterStyle padding="small">
        <DiscountLabel discountCode={discountCode} onClick={onClick} />
        {renderDiscountInfo && (
          <DiscountInfo
            discountApplied={!!cart.discountSpendings}
            spending={totalSpending}
            discount={discount}
          ></DiscountInfo>
        )}
      </FooterStyle>
    );
  }

  return (
    <FooterStyle>
      <Button
        tabIndex={0}
        onClick={onClick}
        onKeyPress={handleConfirmation(onClick)}
        className="Giftbox-Discount-Code-Switch"
      >
        <DiscountIcon className="Giftbox-Discount-Code-Switch-Icon" />
        {settings.discount_prompt}
      </Button>
      {renderDiscountInfo && (
        <DiscountInfo
          discountApplied={!!cart.discountSpendings}
          spending={totalSpending}
          discount={discount}
        ></DiscountInfo>
      )}
    </FooterStyle>
  );
}
